export type NavigationDataEntry = {
    name: string;
    anchor: string;
    file: string;
    registrationLink: boolean;
}

export type NavigationData = {
    name: string;
    path: string;
    image: string;
    elements: NavigationDataEntry[];
}

export const kurse: NavigationData = {
    name: 'Kurse',
    path: 'kurse',
    image: 'Bild_HP_Kurse_und_Babymassagekurs_und_Babymassage_Workshop.jpg',
    elements: [
        {name: 'Babymassage', anchor: 'babymassage', file: 'babymassage_kurs.md', registrationLink: true},
        {name: 'BabySteps ®', anchor: 'babysteps', file: 'babysteps.md', registrationLink: true},
        {name: 'BellyBasics ®', anchor: 'bellybasics', file: 'bellybasics.md', registrationLink: true},
        {name: 'MaxiSteps ®', anchor: 'maxisteps', file: 'maxisteps.md', registrationLink: true},
        {name: 'MiniSigns ®', anchor: 'minisigns', file: 'minisigns.md', registrationLink: true},
        {name: 'MommySteps ®', anchor: 'mommysteps', file: 'mommysteps.md', registrationLink: true},
        {name: 'BabyBoogie ®', anchor: 'babyboogie', file: 'babyboogie.md', registrationLink: true}
    ]
};

export const workshops: NavigationData = {
    name: 'Workshops',
    path: 'workshops',
    image: 'Bild_HP_Workshops.jpg',
    elements: [
        {name: 'Beikost', anchor: 'beikost', file: 'beikost.md', registrationLink: true},
        {name: 'Babyschlaf', anchor: 'babyschlaf', file: 'babyschlaf.md', registrationLink: true},
        {name: 'Babytragen', anchor: 'babytragen', file: 'babytragen.md', registrationLink: true},
        {name: 'Einfach Eltern ®', anchor: 'einfach_eltern', file: 'einfach_eltern.md', registrationLink: true},
        {name: 'Geschwisterkurs', anchor: 'geschwisterkurs', file: 'geschwisterkurs.md', registrationLink: true},
        {
            name: 'Kinderkrankheiten natürlich lindern',
            anchor: 'kinderkrankheiten',
            file: 'kinderkrankheiten_natuerlich_lindern.md',
            registrationLink: true
        },
    ]
};

export const beratungen: NavigationData = {
    name: 'Beratungen',
    path: 'beratungen',
    image: 'Bild_HP_Beratung.jpg',
    elements: [
        {name: 'Trageberatung', anchor: 'trageberatung', file: 'trageberatung.md', registrationLink: false},
        {
            name: 'Beratungsequipment',
            anchor: 'beratungsequipment',
            file: 'beratungsequipment.md',
            registrationLink: false
        },
        {
            name: 'Babyschlafberatung',
            anchor: 'babyschlafberatung',
            file: 'babyschlafberatung.md',
            registrationLink: false
        }
    ]
};

export const angeboteMit: NavigationData = {
    name: 'Angebote mit …',
    path: 'angebote',
    image: 'Bild_HP_Specials.jpg',
    elements: [
        {
            name: 'Hebamme Ann-Kathrin - Rückbildung',
            anchor: 'angebote_ann-kathrin',
            file: 'angebote_ann-kathrin.md',
            registrationLink: false
        },
        {
            name: 'Julia - Pilates n.d. Rückbildung',
            anchor: 'angebote_julia',
            file: 'angebote_julia.md',
            registrationLink: false
        },
        {name: 'Ronja - Musik', anchor: 'angebote_ronja', file: 'angebote_ronja.md', registrationLink: false},
        {
            name: 'Katharina - Aroma & Entspannung',
            anchor: 'angebote_katharina',
            file: 'angebote_katharina.md',
            registrationLink: false
        },
        {
            name: 'Laura - Yoga mit Baby/Kind',
            anchor: 'angebote_laura',
            file: 'angebote_laura.md',
            registrationLink: false
        },
        {
            name: 'Caroline - Frauenkreise',
            anchor: 'angebote_caroline',
            file: 'angebote_caroline.md',
            registrationLink: false
        },
        {
            name: 'Stephanie - Kinderherzen stärken',
            anchor: 'angebote_stephanie',
            file: 'angebote_stephanie.md',
            registrationLink: false
        },
        {name: 'Antje - 1.Hilfe am Kind', anchor: 'angebote_antje', file: 'angebote_antje.md', registrationLink: false},
        {
            name: 'Kooperationspartner',
            anchor: 'kooperationspartner',
            file: 'kooperationspartner.md',
            registrationLink: false
        },
    ]
};

export const babysImGlueck: NavigationData = {
    name: 'Babys im Glück',
    path: 'babys_im_glueck',
    image: 'Startseite_Reiterbild_BabysimGlück.jpg',
    elements: [
        {name: 'Über mich', anchor: 'ueber_mich', file: 'ueber_mich.md', registrationLink: false},
        {name: 'Anfahrt', anchor: 'anfahrt', file: 'anfahrt.md', registrationLink: false},
        {name: 'Gutscheine', anchor: 'gutscheine', file: 'gutscheine.md', registrationLink: false},
        {name: 'Raummiete', anchor: 'raummiete', file: 'raummiete.md', registrationLink: false},
        {name: 'Kontakt', anchor: 'kontakt', file: 'kontakt.md', registrationLink: false},
    ]
};

export const allPages: NavigationData[] = [kurse, workshops, beratungen, angeboteMit, babysImGlueck];
